import React from 'react';
import { Box, Drawer } from '@mui/material';
import useMobileMenu from '../../../../hooks/useMobileMenu';
import {
    SIDEBAR_ADMIN_NAVIGATION,
    SIDEBAR_PROFILE_NAVIGATION,
} from '../../../../utils/constans/SidebarMenu';
import useUserSWR from '../../../../hooks/user/useUserSWR';
import NavigationList from 'components/new-navigation';

export const ProfileMobileDrawer = () => {
    const mobileMenu = useMobileMenu();
    const { user } = useUserSWR();

    const toggleDrawer =
        (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
            if (
                event.type === 'keydown' &&
                ((event as React.KeyboardEvent).key === 'Tab' ||
                    (event as React.KeyboardEvent).key === 'Shift')
            ) {
                return;
            }

            mobileMenu.showProfileMenu(open);
        };

    return (
        <>
            <Drawer
                anchor={'right'}
                open={mobileMenu.mobileMenuStates.profile.open}
                onClose={toggleDrawer(false)}
            >
                <Box padding={1}>
                    <NavigationList menu={SIDEBAR_PROFILE_NAVIGATION} />
                    {user && user.is_admin && (
                        <NavigationList menu={SIDEBAR_ADMIN_NAVIGATION} />
                    )}
                </Box>
            </Drawer>
        </>
    );
};
